import { render, staticRenderFns } from "./animaIndex.vue?vue&type=template&id=7a8ababe&"
import script from "./animaIndex.vue?vue&type=script&lang=js&"
export * from "./animaIndex.vue?vue&type=script&lang=js&"
import style0 from "./animaIndex.vue?vue&type=style&index=0&id=7a8ababe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports